<template>
<transition name="fade">
  <div class="ui dimmer modals page" v-if="showBackDrop" style="display: block !important; overflow-y: scroll;" :style="{ visibility: showBackDrop ? 'visible' : 'hidden', opacity: showBackDrop ? '1' : '0'}" @click="closeModal()">
    <transition name="scale">
      <div :id="id" class="ui modal active visibility" v-show="showModal" :class="[size, type, isScroll ? 'scrolling' : ''] " @click="clickContent($event)">
        <slot></slot>
      </div>
    </transition>
  </div>
</transition>
</template>

<script>
export default {
name: 'modal',
  props: {
    size: {
      type: String,
      default: 'small'
    },
    type: {
      type: String,
      default: ''
    },
    closeable: {
      type: Boolean,
      default: true
    },
    isScroll: {
      type: Boolean,
      default: false
    }

      },

  data() {
    return {
      id: `modal_${Math.random()}`,
      showBackDrop: false,
      showModal: false
        }
  },

  mounted() {
    document.body.classList.add("dimmable");

  },

  methods: {
    clickContent(event) {
      event.stopPropagation();
    },
    open() {
      this.showBackDrop = true
      document.body.classList.add("dimmed");
   //   this.$nextTick(() => {
        this.showModal = true;
       this.$nextTick(() => {
        this.$el.firstChild.style.top = ((document.body.offsetHeight - this.$el.firstChild.offsetHeight) / 2) + 'px';
       // this.$el.children[0].style.top = ((document.body.offsetHeight - this.$el.children[0].style.height) / 2) + 'px';
        })
     // });

    },
    close() {
      this.showModal = false
      setTimeout(() => {
        this.showBackDrop = false
        document.body.classList.remove("dimmed");
      }, 30);
    },
    closeModal() {
      if (!this.closeable) {
        return;
      }
      this.close();
    }

  }
}
</script>


<style>
.modal .header {
  color: #16ab39 !important;
  font-size: 1.6em !important;
  background: #f2fff0 !important;
  padding: 1rem 1.4rem !important;
  border:1px solid rgba(33, 186, 69, 0.13) !important;
text-transform: capitalize;
}

.modal span {font-size: 1.1em !important;}
.modal .content {padding: 1.4em !important;}
.modal .description, span {margin-top: 0 !important;}
.modal .meta {padding-left: 2em !important;}
.modal h3 {
  margin-bottom: 0 !important;
}
.modal form {
  margin-top: 1.5em;
}

@media only screen and (max-width: 767px)
{
.ui.modal .content > .description {
padding-top: 0 !important;
padding-left: 2em !important;
}
}
</style>



// WEBPACK FOOTER //
// Modal.vue?4ea702ae